import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { TWhiteLabelState } from '../types';

const initialState: TWhiteLabelState = {
  nonPartnerWl: false,
  wl: {},
  isWL: false,
  isWLWithJWE: false,
  isWLWithPreviousUserData: false,
  isWLWithShortFooter: false,
  isServerFormValid: false,
  blockFF: undefined,
};

export const whiteLabelSlice = createSlice({
  name: 'whiteLabel',
  initialState,
  reducers: {
    setWhiteLabel: (_, { payload }: PayloadAction<TWhiteLabelState>) => {
      const {
        wl,
        nonPartnerWl: isNonPartnerWl,
        isFullLanding,
        isWLWithPreviousUserData,
        isWLWithJWE,
        isWL,
        isWLWithShortFooter,
        blockFF,
        isServerFormValid,
      } = payload;

      return {
        wl,
        nonPartnerWl: isNonPartnerWl,
        isWLWithJWE,
        isFullLanding,
        isWLWithPreviousUserData,
        isWLWithShortFooter,
        isWL,
        blockFF,
        isServerFormValid,
      };
    },
  },
});
